import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["question", "answer", "label", "isOnGradingProcess"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from '@xstyled/styled-components';
import { Checkbox, Space } from 'antd';
import { MathEnabledTextComponent, styleVariables } from '@lib/common';
import { GradingAnswer } from './base-answer.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledSpace = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledCheckBox = styled(Checkbox)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1;\n  cursor: default;\n"])));
var StyledAnswerDescription = styled(MathEnabledTextComponent)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  font-size: ", ";\n  color: ", ";\n\n  p {\n    margin-bottom: 0;\n  }\n"])), styleVariables.font.fontWeightNormal, styleVariables.font.fontSizeSmall, function (props) {
  return props.theme.color.fontColorDefault;
});
var StyledQuestionAnswerItem = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n"])));
var StyledCorrectText = styled.label(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (props) {
  return props.theme.color.fontColorSuccess;
});
export var GradingMultipleChoice = function GradingMultipleChoice(_ref) {
  var question = _ref.question,
      answer = _ref.answer,
      label = _ref.label,
      isOnGradingProcess = _ref.isOnGradingProcess,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(GradingAnswer, _objectSpread(_objectSpread({
    label: label,
    question: question,
    disabled: isOnGradingProcess
  }, rest), {}, {
    children: /*#__PURE__*/_jsx(StyledSpace, {
      direction: "vertical",
      children: question.answers.map(function (questionAnswer) {
        var isSelectedAnswer = answer === null || answer === void 0 ? void 0 : answer.values.some(function (value) {
          return value.answerId === questionAnswer.id.toString();
        });
        var isCorrectAnswer = question.correctAnswers.some(function (c) {
          return c.answerId === questionAnswer.id.toString();
        });
        return /*#__PURE__*/_jsx(StyledQuestionAnswerItem, {
          children: /*#__PURE__*/_jsx(StyledCheckBox, {
            value: questionAnswer.id.toString(),
            checked: isSelectedAnswer,
            disabled: true,
            children: /*#__PURE__*/_jsxs(Space, {
              children: [/*#__PURE__*/_jsx(StyledAnswerDescription, {
                value: questionAnswer.description
              }), isCorrectAnswer && /*#__PURE__*/_jsxs(StyledCorrectText, {
                children: ["(", label.correctAnswer, ")"]
              })]
            })
          }, questionAnswer.id.toString())
        }, questionAnswer.id.toString());
      })
    })
  }));
};